import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { TransitionContainerNoExit } from '../../components/Transition/TranstionContainer';

import ConfirmationCard from '../../components/Shared/ConfirmationCard';
import { Title } from '../../components/Shared/TitleSuccess';
import { copyFor } from '../../copy/copy';
import { ActionTypes } from '../../utils/enums';

import { setExitingCardProps, getExitingCardProps } from '../Widget/actions';

const TitleComponent = props => (
    <Title>
        {props.organizationName
            ? copyFor('feedback', 'thanksWithOrg', 'volunteer', undefined, {
                  organizationName: props.organizationName
              })
            : copyFor('feedback', 'thanks', 'volunteer')}
    </Title>
);

TitleComponent.propTypes = {
    organizationName: PropTypes.string
};

const VolunteerSuccess = props => (
    <TransitionContainerNoExit>
        <ConfirmationCard
            thankYouText={props.thankYouText}
            titleComponent={
                <TitleComponent orgName={props.volunteerOpportunity.parentOrg.name} />
            }
            hideSubtitle={true}
            beforeAdvancing={() => {
                props.setExitingCardProps('volunteer', props, props.exitingAction);
            }}
            {...props}
        />
    </TransitionContainerNoExit>
);

VolunteerSuccess.propTypes = {
    exitingAction: PropTypes.object.isRequired,
    thankYouText: PropTypes.string.isRequired,
    organizationName: PropTypes.string,
    setExitingCardProps: PropTypes.func.isRequired,
    volunteerOpportunity: PropTypes.object
};

export default connect(
    (state, props) => {
        const exitingProps = getExitingCardProps(
            'volunteer',
            ['/volunteer/success'],
            props.location.pathname,
            state
        );
        if (exitingProps) return exitingProps;

        return {
            exitingAction: state.widget.activeAction,
            thankYouText: copyFor('feedback', 'verifyEmail', 'volunteer'),
            volunteerOpportunity: state.volunteer.selectedVolunteerOpportunity,
            organizationName: state.volunteer.selectedVolunteerOpportunity.parentOrg.name
        };
    },
    { setExitingCardProps },
    null,
    {
        areStatesEqual: (next, prev) => {
            if (next.widget.activeAction.type !== ActionTypes.Volunteer) return true;

            return next === prev;
        }
    }
)(VolunteerSuccess);
